export default __webpack_public_path__ + "static/media/testResults.9dd420c1.svg";